export const DEFAULT_BANNER_COLOR = "#1A3C5E";

export const DEFAULT_BANNER_TEXT_ES =
  "Instagram + Web + Automatización · Auditoría sin coste · Sistema de reservas 24/7";

export const DEFAULT_BANNER_TEXT_EN =
  "Instagram + Web + Automation · Free audit · A 24/7 booking system";

export const BANNER_COLOR_OPTIONS = [
  { hex: "#1A3C5E", label: "Azul" },
  { hex: "#0F2740", label: "Azul oscuro" },
  { hex: "#1F4A4A", label: "Petróleo" },
  { hex: "#000000", label: "Negro" },
  { hex: "#2C2C2C", label: "Grafito" },
  { hex: "#3F2A1D", label: "Café" },
] as const;

const ALLOWED: Set<string> = new Set(BANNER_COLOR_OPTIONS.map((option) => option.hex));

export type SiteBanner = {
  enabled: boolean;
  textEs: string;
  textEn: string;
  backgroundColor: string;
  updatedAt?: string | null;
};

export const DEFAULT_SITE_BANNER: SiteBanner = {
  enabled: true,
  textEs: DEFAULT_BANNER_TEXT_ES,
  textEn: DEFAULT_BANNER_TEXT_EN,
  backgroundColor: DEFAULT_BANNER_COLOR,
};

export function normalizeBannerColor(value: string | null | undefined): string {
  if (typeof value !== "string") return DEFAULT_BANNER_COLOR;
  const hex = value.trim().toUpperCase();
  const normalized = hex.startsWith("#") ? hex : `#${hex}`;
  return ALLOWED.has(normalized) ? normalized : DEFAULT_BANNER_COLOR;
}

export function bannerTextForLanguage(banner: SiteBanner, language: string): string {
  const es = banner.textEs.trim();
  const en = banner.textEn.trim();
  if (language.toLowerCase().startsWith("en")) return en || es;
  return es || en;
}
